import {
  Divider,
  Grid,
  IconButton,
  Link,
  Stack,
  Typography,
  Box // Import Box for flexible layout
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import logo from "../images/fasset_master_logo.png";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useNavigate } from "react-router-dom";
import TikTokIcon from "./TikTokIcon";
import YouTubeIcon from "@mui/icons-material/YouTube";

const LinksFooter = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        py: 4,
        px: { xs: 2, md: 4, lg: 8 },
        mt: 4
      }}
    >
      {/* Main Footer Grid */}
      <Grid
        container
        spacing={{ xs: 2, md: 4 }}
        justifyContent="space-around"
        alignItems="flex-start"
        sx={{
          // borderTopWidth: 1,
          // borderTopStyle: "solid",
          // borderTopColor: theme.palette.primary.contrastText,
          pt: 4,
          pb: 2
        }}
      >
        {/* Column 1: Logo and Social Media */}
        <Grid item xs={12} md={3} order={{ xs: 1, md: 1 }}>
          <Stack
            direction="column"
            alignItems={{ xs: "center", md: "flex-start" }}
            spacing={2}
          >
            <Box sx={{ width: 150, mb: 1 }}>
              <img
                src={logo}
                alt="Fasset Logo"
                style={{ width: "100%", height: "auto", filter: "brightness(0) invert(1)" }} // Invert logo for dark background
              />
            </Box>
            <Stack direction="row" spacing={1} zIndex={1}>
              <IconButton
                onClick={() => {
                  window.open("https://www.facebook.com/fasset.org", "_blank");
                }}
                sx={{ color: theme.palette.primary.contrastText }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                onClick={() => {
                  window.open("https://www.instagram.com/fasset_sa", "_blank");
                }}
                sx={{ color: theme.palette.primary.contrastText }}
              >
                <InstagramIcon />
              </IconButton>
              <IconButton
                onClick={() => {
                  window.open("https://x.com/fasset_sa", "_blank");
                }}
                sx={{ color: theme.palette.primary.contrastText }}
              >
                <TwitterIcon />
              </IconButton>
              <IconButton
                onClick={() => {
                  window.open(
                    "https://www.linkedin.com/company/financial-and-accounting-services-seta-fasset-/mycompany/",
                    "_blank"
                  );
                }}
                sx={{ color: theme.palette.primary.contrastText }}
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                onClick={() => {
                  window.open("https://www.youtube.com/@fasset_sa", "_blank");
                }}
                sx={{ color: theme.palette.primary.contrastText }}
              >
                <YouTubeIcon />
              </IconButton>
              <IconButton
                onClick={() => {
                  window.open("https://www.tiktok.com/@fasset_sa", "_blank");
                }}
                sx={{ color: theme.palette.primary.contrastText }}
              >
                <TikTokIcon />
              </IconButton>
            </Stack>
          </Stack>
        </Grid>

        {/* Column 2: Quick Links */}
        <Grid item xs={12} md={3} order={{ xs: 2, md: 2 }}>
          <Stack
            direction="column"
            alignItems={{ xs: "center", md: "flex-start" }}
            spacing={1}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: 1, fontSize: '1.1rem' }}
            >
              Quick Links
            </Typography>
            <LinkButton text="About us" onClick={() => navigate("/whoweare")} />
            <LinkButton
              text="Invoice Management"
              onClick={() =>
                window.open("https://invoices.fasset.org.za/", "_blank")
              }
            />
            <LinkButton
              text="ODOO LMIS"
              onClick={() =>
                window.open("https://portal.fasset.org.za/", "_blank")
              }
            />
            <LinkButton
              text="Learner Portal"
              onClick={() =>
                window.open(
                  "https://www.learner-portal.fasset.org.za",
                  "_blank"
                )
              }
            />
            <LinkButton
              text="Constitution"
              onClick={() => navigate("/constitution")}
            />
            <LinkButton text="Policies" onClick={() => navigate("/policies")} />
          </Stack>
        </Grid>

        {/* Column 3: Whistle Blowers */}
        <Grid item xs={12} md={3} order={{ xs: 3, md: 3 }}>
          <Stack
            direction="column"
            alignItems={{ xs: "center", md: "flex-start" }}
            spacing={1}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: 1, fontSize: '1.1rem' }}
            >
              Whistle Blowers
            </Typography>
            <InfoItem label="Toll Free Number:" value="0800 472 637" />
            <InfoItem label="Email:" value="fasset@whistleblowing.co.za" />
            <InfoItem label="WhatsApp ChatBot:" value="031 308 4664" />
            <InfoItem label="Postal:" value="FREEPOST KZN665, MUSGRAVE, 4062" />
            <InfoItem label="SMS:" value="33490" />
            <InfoItem
              label="Online:"
              value="www.whistleblowing.co.za"
              link="https://www.whistleblowing.co.za"
            />
            <InfoItem
              label="Mobile App:"
              value="Google Play and Apple App stores"
            />
          </Stack>
        </Grid>

        {/* Column 4: Regional Offices - Now integrated into the bottom bar */}
        <Grid item xs={12} md={3} order={{ xs: 4, md: 4 }}>
        <Stack
            direction="column"
            alignItems={{ xs: "center", md: "flex-start" }}
            spacing={1}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: 1, fontSize: '1.1rem' }}
            >
              Head Office
            </Typography>
            <Stack
              direction="row"
              alignItems="flex-start"
              spacing={0.5}
              sx={{ cursor: "pointer" }}
              onClick={() => {
                window.open(
                  "https://www.google.com/maps/place/Fasset+Financial+%26+Accounting+Sector+Education+And/@-26.0948292,27.9973029,17z/data=!3m1!4b1!4m6!3m5!1s0x1e950ad4f694dd9d:0xfdcbc0464976f09e!8m2!3d-26.0948292!4d27.9998778!16s%2Fg%2F11b6d7d4fn?entry=ttu",
                  "_blank"
                );
              }}
            >
              <LocationOnIcon sx={{ fontSize: 16, color: theme.palette.primary.contrastText }} />
              <Typography
                variant="body2"
                sx={{ fontSize: { xs: 10, md: 12 }, color: theme.palette.primary.contrastText }}
              >
                1st floor, 296 Kent Ave, Ferndale, Randburg, 2194
              </Typography>
            </Stack>
            <Box height={10} /> {/* Spacer */}
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: 1, fontSize: '1.1rem' }}
            >
              Regional Offices
            </Typography>

            <Stack
              direction="row"
              alignItems="flex-start"
              spacing={0.5}
              sx={{ cursor: "pointer" }}
            >
              <LocationOnIcon sx={{ fontSize: 16, color: theme.palette.primary.contrastText }} />
              <Typography
                variant="body2"
                sx={{ fontSize: { xs: 10, md: 12 }, color: theme.palette.primary.contrastText }}
              >
                <span style={{ fontWeight: 'bold' }}>Limpopo Office:</span> Vhembe TVET College Site 203 Unit A Sibasa 2256 Makwarela Street Sibasa Tel: 087 562 8274
              </Typography>
            </Stack>
            <Box height={10} /> {/* Spacer */}
            <Stack
              direction="row"
              alignItems="flex-start"
              spacing={0.5}
              sx={{ cursor: "pointer" }}
            >
              <LocationOnIcon sx={{ fontSize: 16, color: theme.palette.primary.contrastText }} />
              <Typography
                variant="body2"
                sx={{ fontSize: { xs: 10, md: 12 }, color: theme.palette.primary.contrastText }}
              >
                <span style={{ fontWeight: 'bold' }}>KwaZulu-Natal Office:</span> eThekwini TVET College, 75 Earl Haig Rd, Morningside, Berea, 4001 TEL: 087 562 8281
              </Typography>
            </Stack>
          </Stack>
        </Grid>
      </Grid>

      {/* Bottom Bar */}
      <Divider sx={{ my: 4, borderColor: theme.palette.primary.contrastText }} />
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="center"
        alignItems="center"
        spacing={{ xs: 2, md: 4 }}
      >
        <Typography
          textAlign="center"
          variant="body2"
          sx={{ fontSize: { xs: 10, md: 12 }, color: theme.palette.primary.contrastText }}
        >
          {`Copyright © ${new Date().getFullYear()} - Fasset Rights Reserved`}
        </Typography>
        <Stack
          direction="row"
          spacing={2}
          divider={<Divider orientation="vertical" flexItem sx={{borderColor: theme.palette.primary.contrastText}}/>}
          alignItems="center"
        >
          <Link
            component="button"
            onClick={() => navigate("/policies")}
            variant="body2"
            sx={{
              color: theme.palette.primary.contrastText,
              textDecoration: "none",
              "&:hover": { textDecoration: "underline", color: theme.palette.secondary.main }
            }}
          >
            FASSET Policy
          </Link>
        </Stack>
      </Stack>
    </Box>
  );
};

// Helper component for consistent link styling
const LinkButton = ({ text, onClick }) => (
  <Link
    component="button"
    onClick={onClick}
    sx={{
      color: "inherit", // Inherit color from parent Box
      fontWeight: "normal",
      textDecoration: "none",
      cursor: "pointer",
      "&:hover": {
        color: "white", // Darker hover color
        textDecoration: "underline"
      }
    }}
  >
    {text}
  </Link>
);

// Helper component for info items
const InfoItem = ({ label, value, link }) => (
  <Stack
    direction="row"
    spacing={1}
    alignItems="flex-start"
    sx={{ width: "100%", justifyContent: { xs: "center", md: "flex-start" } }}
  >
    <Typography fontWeight="bold" sx={{ color: "inherit" }}>
      {label}
    </Typography>
    {link ? (
      <Link
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          color: "inherit",
          textDecoration: "none",
          "&:hover": {
            color: "white", // Darker hover color
            textDecoration: "underline"
          }
        }}
      >
        <Typography sx={{ color: "inherit" }}>{value}</Typography>
      </Link>
    ) : (
      <Typography sx={{ color: "inherit" }}>{value}</Typography>
    )}
  </Stack>
);

export default LinksFooter;
